import "./hr.css";

export const Hr = () => <div className="hr" />;
